<template>
  <div id="body-id" class="width-100 min-height flex-column align-items-center justify-content-start" style="background: #f6f6f6">
    <van-image width="100%" height="12rem" :src="itemDetail.goods_picture_url" fit="contain" />
    <div
      class="flex-column align-items-center justify-content-around width-100 bg-blue"
      :style="{ height: (bodyIdWidth / 750) * 115 + 'px', padding: '2% 3%' }"
    >
      <div class="flex-row align-items-center justify-content-spaceBetween width-100">
        <div
          class="bg-white br-big fm-sh-normal"
          style="font-size: 12px; transform: scale(0.8); color: #0053f0; padding: 2px 8px; line-height: 12px; margin-left: -5px"
        >
          本期奖品
        </div>
        <div class="white fm-sh-medium" v-if="!hide" style="font-size: 12px; transform: scale(0.8); margin-right: -5px">距离结束还剩:</div>
      </div>
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween">
        <div class="white fm-sh-regular fs-mid-sml">{{ itemDetail.goods_name }}</div>
        <!-- <van-count-down :time="itemDetail.endTime">          <template #default="timeData">            <div class="flex-row align-items-end">              <span style="display: inline-block" class="white fs-sml fm-sh-medium margin-rs"> {{ timeData.days }}天 </span>              <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card fm-sh-light">                {{ timeData.hours }}              </span>              <span class="colon white">:</span>              <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card fm-sh-light">                {{ timeData.minutes }}              </span>              <span class="colon white">:</span>              <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card fm-sh-light">                {{ timeData.seconds }}              </span>            </div>          </template>        </van-count-down> -->
        <div class="flex-row align-items-end justify-content-around" v-if="!hide">
          <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card">{{ dayTime }}</span
          >: <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card">{{ hourTime }}</span
          >: <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card">{{ minuteTime }}</span
          >: <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card">{{ secondTime }}</span>
        </div>
      </div>
    </div>
    <div class="bg-white width-100 margin-bss flex-column align-items-star justify-content-center" style="padding: 2% 5%">
      <div style="color: #666" class="fs-mid-sml fm-sh-regular">奖品数量：{{ itemDetail.goods_num }}份</div>
      <div style="color: #666" class="fs-mid-sml fm-sh-regular" v-if="itemDetail.end_time">活动结束时间：{{ itemDetail.end_time }}</div>
      <div style="color: #666" class="fs-mid-sml fm-sh-regular">参与次数：{{ itemDetail.involved_num }}</div>
    </div>
    <div
      class="width-100 textAlign-c fw-mid fs-big margin-bss"
      v-if="showZJ"
      style="background: #e1efff; color: #0053f0; height: 2.5rem; line-height: 2.5rem"
    >
      已开奖，请前往中奖记录查看。
    </div>
    <div class="bg-white width-100 flex-row align-items-center justify-content-around" style="padding: 3% 5% 0">
      <div class="width-100 flex-row align-items-center justify-content-around" style="border-bottom: 1px solid #eee; padding-bottom: 10px">
        <div
          :class="['fs-mid-sml', active == 0 ? 'fm-sh-bold' : 'fm-sh-regular']"
          :style="{ color: active == 0 ? '#0053f0' : '#666' }"
          @click="active = 0"
        >
          产品介绍
        </div>
        <div
          :class="['fs-mid-sml', active == 1 ? 'fm-sh-bold' : 'fm-sh-regular']"
          :style="{ color: active == 1 ? '#0053f0' : '#666' }"
          @click="getActiveList(1)"
        >
          投注记录
        </div>
        <div
          :class="['fs-mid-sml', active == 2 ? 'fm-sh-bold' : 'fm-sh-regular']"
          :style="{ color: active == 2 ? '#0053f0' : '#666' }"
          @click="getActiveList(2)"
        >
          我的奖券
        </div>
        <!-- <div          v-if="itemDetail.lottery_state == 1"          :class="['fs-mid-sml', active == 3 ? 'fm-sh-bold' : 'fm-sh-regular']"          :style="{ color: active == 3 ? '#0053f0' : '#666' }"          @click="active = 3"        >          开奖结果        </div> -->
      </div>
    </div>
    <div v-if="active == 0" v-html="itemDetail.details" class="width-100"></div>
    <div v-if="active == 1 || active == 2" class="flex-column width-100 bg-white align-items-center" style="padding: 0 5% 3%">
      <van-list v-model="loading" :finished="finished" :finished-text="list.length == 0 ? '' : '没有更多了'" @load="onLoad" class="width-100">
        <div
          v-show="list.length != 0"
          class="flex-row align-items-center justify-content-spaceBetween width-100"
          style="height: 3.5rem; border-bottom: 1px solid #eee"
          v-for="(item, key) in list"
          :key="key"
        >
          <div class="fm-sh-regular fs-mid-sml margin-r">{{ item.lottery_ticket }}</div>
          <div class="fs-sml fm-sh-regular grey-999">{{ item.cre_time }}</div>
        </div>
        <div v-if="list.length == 0" style="height: 10rem; line-height: 10rem" class="textAlign-c fs-mid-big grey-999">暂无奖券</div>
      </van-list>
    </div>
    <div class="width-100" style="height: 10rem"></div>
    <div class="width-100 padding-90 flex-row bg-white align-items-center justify-content-spaceBetween" style="position: fixed; bottom: 0; right: 0">
      <div class="fs-mid" style="color: #3183ff">1注={{ itemDetail.redeem_points }}积分</div>
      <div
        class="white fs-mid-sml br-reg"
        :style="{ background: itemDetail.lottery_state == 2 ? '#1E67F7' : '#999999', padding: '0 5px', lineHeight: '1.5rem' }"
        @click="itemDetail.lottery_state == 2 ? (showpopup = true) : ''"
      >
        {{ itemDetail.lottery_state == 2 ? '立即兑换' : '兑换结束' }}
      </div>
    </div>
    <van-popup v-model="showpopup" class="width-80 br-mid">
      <div class="width-100 bg-white padding-lr" style="padding-top: 20px">
        <div class="width-100 textAlign-c fs-20">您确定要兑换奖券吗</div>
        <div class="flex-row align-items-center margin-t justify-content-center width-100" style="border-top: 1px solid #eee">
          <div class="width-49 textAlign-c fs-big padding-Tb-20" style="border-right: 1px solid #eee" @click="showpopup = false">取消</div>
          <div class="width-49 textAlign-c fs-big padding-Tb-20 red" @click="startPush">确定</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
let interval = null;
// eslint-disable-next-line no-unused-vars
import { get_activity_record_info, get_activity_member_ticket_lists, redeem_lottery } from '@/api/quarterlyPrize.js';
import { Toast } from 'vant';
export default {
  data() {
    return {
      showpopup: false,
      loading: false,
      finished: false,
      showZJ: false,
      dayTime: 0,
      hourTime: 0,
      minuteTime: 0,
      secondTime: 0,
      active: 0,
      bodyIdWidth: 0,
      list: [],
      itemDetail: {},
      hide: false,
      searchObj: { pageNum: 0 }
    };
  },
  watch: {
    '$route.path': {
      deep: true,
      handler(v, o) {
        if (o == '/luckyDrawDetails') {
          console.log(o);
          this.$destroy();
        }
      }
    }
  },
  beforeMount() {
    this.getActivityMemberTicketLists();
    get_activity_record_info({ id: this.$route.query.id })
      .then((res) => {
        if (res.code == 0) {
          this.itemDetail = res.data;
          clearInterval(interval);
          interval = setInterval(() => {
            let times = this.daysDistance(res.data.end_time.replace(/-/g, '/'), new Date());
            if (times < 0) {
              this.hide = true;
              clearInterval(interval);
            } else {
              let day = Math.floor(times / 1000 / 3600 / 24);
              let hour = Math.floor(times / 1000 / 3600);
              let minutes = Math.floor(times / 1000 / 60);
              this.dayTime = Math.floor(times / 1000 / 3600 / 24);
              this.hourTime = Math.floor(times / 1000 / 3600) - day * 24;
              this.minuteTime = Math.floor(times / 1000 / 60) - hour * 60;
              this.secondTime = Math.floor(times / 1000) - minutes * 60;
            }
          }, 1000);
        } else {
          Toast.fail('获取奖品信息失败');
          // this.$router.back();
        }
      })
      .catch((err) => {
        console.log(err);
      });
    this.$nextTick(() => {
      this.bodyIdWidth = document.getElementById('body-id').clientWidth;
    });
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(interval);
    next();
  },
  methods: {
    getActivityMemberTicketLists() {
      get_activity_member_ticket_lists({ id: this.$route.query.id, page: this.searchObj.pageNum, type: this.active == 0 ? 1 : this.active })
        .then((res) => {
          if (res.code == 0) {
            this.list = this.list.concat(res.data);
            this.list.forEach((item) => {
              if (item.state == 1) {
                this.showZJ = true;
              }
            });
            if (res.data.length == 0) {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //date1和date2是2019-06-18格式
    daysDistance(date1, date2) {
      //parse() 是 Date 的一个静态方法 , 所以应该使用 Date.parse() 来调用，而不是作为 Date 的实例方法。返回该日期距离 1970/1/1 午夜时间的毫秒数
      date1 = Date.parse(date1);
      date2 = Date.parse(date2);
      //计算两个日期之间相差的毫秒数的绝对值
      var ms = date1 - date2; //毫秒数除以一天的毫秒数,就得到了天数
      return ms;
    },
    getActiveList(type) {
      this.active = type;
      this.list = [];
      this.searchObj.pageNum = 0;
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    onLoad() {
      this.searchObj.pageNum += 1;
      this.getActivityMemberTicketLists();
    },
    startPush() {
      this.showpopup = false;
      if (this.itemDetail.lottery_state == 2) {
        const _this = this;
        //
        // redeem_lottery({ id: this.$route.query.id, session_id: this.$store.state.userInfo.session_id }).then((res) => {
        // eslint-disable-next-line no-undef
        CP.getUniqueId({
          completed: (data) => {
            redeem_lottery({ id: _this.$route.query.id, session_id: data.unique_id }).then((res) => {
              if (res.code == 0) {
                Toast('兑换成功！');
                this.getActiveList(2);
              } else {
                Toast(res.msg);
              }
            });
          },
          cpIncompatible: () => {
            Toast('此环境不支持此方法');
          }
        });
        // });
      }
    }
  }
};
</script>

<style scoped>
.time-card {
  border-radius: 0.25rem;
  background: #fff;
  width: 1.3rem;
  height: 1.3rem;
  text-align: center;
  line-height: 1.3rem;
  font-size: 12px;
}
::v-deep .van-tabs__line {
  display: none;
}
::v-deep .van-tabs__wrap {
  border-bottom: 1px solid #efeff4;
}
</style>
